import { render } from "./mobile-money-zambia.vue?vue&type=template&id=58b64344"
import script from "./mobile-money-zambia.vue?vue&type=script&lang=js"
export * from "./mobile-money-zambia.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__